var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 11.703 12.555",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2eced5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-17.379)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.379 1.885)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M306,175.092l-.983-.036-.213,5.819.983.036Z",
    transform: "translate(-297.759 -172.648)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.983,
    height: 5.819,
    transform: "translate(5.36 2.426)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M159.615,180.868l-.213-5.819-.983.036.213,5.819Z",
    transform: "translate(-154.96 -172.641)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.379,76.867v.983H18.4l.813,9.238a.492.492,0,0,0,.49.449h7.031a.492.492,0,0,0,.49-.449l.813-9.238h1.041v-.983Zm8.908,9.687H20.157l-.766-8.7h7.662Z",
    transform: "translate(-17.379 -76.867)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.805)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M161.108,0H157.9a.82.82,0,0,0-.82.82V2.377h.983V.983h2.885V2.377h.983V.82A.82.82,0,0,0,161.108,0Z",
    transform: "translate(-157.076)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.d89b3576.svg";
export { ForwardRef as ReactComponent };